// extracted by css-extract-rspack-plugin
export default {"spinner":"vQSG5BkZ","preloaderAnimation":"mPyAJGJF"};